var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ContractorManagerInformationProvider", {
    staticClass: "flex justify-between w-full",
    attrs: { user: _vm.user },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({
          isRequestContractorShown,
          isContractorRequested,
          contractorId,
          isAccessGranted,
        }) {
          return [
            isAccessGranted && _vm.showText
              ? _c("CardInfoChip", { attrs: { message: "Access Granted" } })
              : _vm._e(),
            isContractorRequested && _vm.showText
              ? _c("CardInfoChip", {
                  attrs: { message: "Requested", gray: "" },
                })
              : _vm._e(),
            isRequestContractorShown
              ? _c("AddContractorToCompany", {
                  staticClass: "w-full",
                  attrs: {
                    buttonText: "Request access",
                    buttonSize: "no",
                    buttonVariant: _vm.variant,
                    contractorId: contractorId,
                    currentUserRole: _vm.currentUser.role,
                    currentUserId: _vm.currentUser.id,
                    companyId: _vm.company.id,
                    companyName: _vm.company.business_name,
                    contractorUserId: _vm.user.id,
                  },
                  on: {
                    addedToCompany: function ($event) {
                      return _vm.$emit("contractorAdded")
                    },
                  },
                })
              : _vm._e(),
            isContractorRequested
              ? _c("RemoveManagerContractorRequest", {
                  staticClass: "w-full",
                  attrs: {
                    buttonSize: "no",
                    buttonVariant: _vm.variant,
                    contractorId: contractorId,
                    managerId: _vm.currentUser.manager.id,
                  },
                  on: {
                    requestRemoved: function ($event) {
                      return _vm.$emit("contractorRemoved")
                    },
                  },
                })
              : _vm._e(),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }